import { NotificationSettingModel } from './NotificationSetting';
var NotificationSettingFormModel = /** @class */ (function () {
    function NotificationSettingFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.accountId, accountId = _b === void 0 ? null : _b, _c = _a.id, id = _c === void 0 ? null : _c, _d = _a.isNotify, isNotify = _d === void 0 ? false : _d, _e = _a.frequency, frequency = _e === void 0 ? null : _e;
        this.id = id;
        this.accountId = accountId;
        this.isNotify = isNotify;
        this.frequency = frequency;
        this.originalIsNotify = isNotify;
        this.originalFrequency = frequency;
    }
    NotificationSettingFormModel.prototype.isChanged = function () {
        return (this.frequency !== this.originalFrequency ||
            this.isNotify !== this.originalIsNotify);
    };
    NotificationSettingFormModel.prototype.addChangedNotification = function (items, method, type, status, accountId) {
        if (!this.isChanged())
            return;
        var typeStatus = type + status;
        items.push(NotificationSettingModel.assign({
            accountId: accountId,
            id: this.id,
            isNotify: this.isNotify,
            frequency: this.frequency,
            notificationMethod: method,
            notificationType: typeStatus,
        }));
    };
    return NotificationSettingFormModel;
}());
export { NotificationSettingFormModel };
